<template>
  <div>
    <el-dialog
      class="small-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelProps.visible"
      :title="modelProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelContextForm"
        :rules="modelTreeFormRules"
        ref="modelForm"
        label-width="150px"
        :disabled="modelProps.editType === 'read'"
      >
        <el-form-item :label="`分类/路径`" prop="directoryId">
          <el-select
            ref="modelTree"
            v-model="modelContextForm.modelClassName"
            popper-class="model-select-tree"
            :popper-append-to-body="false"
            :placeholder="`请选择分类/路径`"
            filterable
          >
            <el-option :label="pathStr" :value="pathId">
              <el-tree
                :props="{
                  children: 'childrens',
                  label: 'name',
                }"
                node-key="id"
                highlight-current
                @node-click="treeNodeClick"
                :expand-on-click-node="false"
                :load="loadTreeData"
                lazy
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`上传${pageTitle}文件`" prop="modelFile">
          <el-upload
            drag
            :auto-upload="false"
            action="https://xx.yy.zz"
            :on-remove="
              (file, fileList) => {
                handleRemove(file, fileList, 'fileList')
              }
            "
            :on-change="
              (file, fileList) => {
                handleChange(file, fileList, 'fileList')
              }
            "
            :file-list="fileList"
            :accept="accept.join(',')"
          >
            <i class="el-icon-upload text-76px"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__text">支持扩展名：{{ accept.join('、') }}</div>
            <div slot="file" slot-scope="{ file }">
              <div>
                <span>{{ file.name }}</span>
                <span v-if="file.msg" class="ml-10px">{{ file.msg }}</span>
                <el-progress
                  :percentage="file.percent"
                  :stroke-width="8"
                  :text-inside="false"
                  v-if="file.parse"
                />
              </div>
              <span class="el-upload-list_item-actions">
                <span
                  class="el-upload-list_item-delete"
                  @click="handleRemove(file, fileList, 'fileList')"
                >
                  <i class="el-icon-close"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <template v-if="modelForm.id">
          <el-form-item :label="`上传${pageTitle}贴图`" prop="modelMaps">
            <el-upload
              drag
              :auto-upload="false"
              action="https://xx.yy.zz"
              :on-remove="
                (file, fileList) => {
                  handleRemove(file, fileList, 'modelMapsFileList')
                }
              "
              :on-change="
                (file, fileList) => {
                  handleChange(file, fileList, 'modelMapsFileList')
                }
              "
              :file-list="modelMapsFileList"
              :accept="'.zip'"
            >
              <i class="el-icon-upload text-76px"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__text">支持扩展名：.zip</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="`上传${pageTitle}缩略图`" prop="modelPic">
            <el-upload
              drag
              :auto-upload="false"
              action="https://xx.yy.zz"
              :on-remove="
                (file, fileList) => {
                  handleRemove(file, fileList, 'modelPicFileList')
                }
              "
              :on-change="
                (file, fileList) => {
                  handleChange(file, fileList, 'modelPicFileList')
                }
              "
              :file-list="modelPicFileList"
              :accept="'.png,.jpg,.jpeg'"
            >
              <i class="el-icon-upload text-76px"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__text">支持扩展名：.png、.jpg、.jpeg'</div>
            </el-upload>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelProps.editType !== 'read'">
        <template v-if="!isParseModel">
          <el-button size="small" type="primary" @click="save()" :loading="saveLoading"
            >保存</el-button
          >
          <el-button size="small" @click="close(false)">取消</el-button>
        </template>
        <el-button size="small" @click="close(true)" v-else>关闭</el-button>
      </div>
    </el-dialog>
    <model-view-vk
      v-if="showModelView"
      ref="modelView"
      class="bg-white absolute left-999px top-999px"
      playerEngineId="splitEngineId"
      :cloudRender="cloudRender"
      :modelProps="modelData"
      :showDocComponent="false"
      :modelParams="modelParams"
      :modelName="modelName"
      :basicTabBar="[]"
      :businessTabBar="[]"
      @sendPlayer="($event) => (mainPlayer = $event)"
      @LoadedAllModel="loadedAllModel"
      @loadError="loadError"
    ></model-view-vk>
  </div>
</template>
<script>
import { get, chunk } from 'lodash'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import * as XLSX from 'xlsx'
import documentManagementService from '@/services/documentManagement'
import DocumentService from '@/services/DocumentService'
import ModelServer from '../services/modelServer'

const ModelViewVk = () => {
  return import('@/modules/resource/components/model/ModelViewVk')
}
export default {
  name: 'operateModelDialog',
  components: {
    ModelViewVk,
  },
  props: {
    currentStandardItemCode: {
      type: String,
      default: '',
    },
    moduleConfig: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 当前选中目录
    currentTreeSelect: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 弹框操作类型
    modelProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增模型',
          editType: 'create',
        }
      },
    },
    // 查看、编辑表
    modelForm: {
      type: Object,
      default: () => {
        return {
          name: '',
          orderNumber: '',
          directoryId: '',
          lables: [],
          modelFile: [],
          modelClassName: '',
        }
      },
    },
    // 分类树
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    flatTreeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 页面信息 默认为模型库页面
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageTitle: '模型',
          materialType: 1,
        }
      },
    },
    tableFormDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadProgressText: '',
      uploadLoading: false,
      // 表单
      modelContextForm: {
        name: '',
        directoryId: '',
        lables: [],
        modelFile: [],
        modelClassName: '',
        version: '', // 版本
      },
      // 查看屏蔽标签新增
      inputVisible: false,
      // 输入框内容
      inputValue: '',
      // 表单保存状态
      saveLoading: false,
      // 请求实例
      requestInstance: null,
      // 文件列表信息
      fileMedias: [],
      modelPicFileList: [],
      modelMapsFileList: [],
      fileList: [], // 上传文件
      accept: ['.pr', '.pprj', '.rvm', '.fbx', '.vue'], // 上传文件类型
      pathStr: '', // 分类/路径
      pathId: '', // 分类/路径对应id
      parseQueue: [],
      showModelView: false,
      modelParams: [],
      modelData: {},
      modelName: '',
      isParseModel: false,
    }
  },
  computed: {
    config() {
      return Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config || {}
    },
    cloudRender() {
      return cloudRender
    },
    // 弹框标题
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
    // 弹框类型
    materialType() {
      return get(this.pageInfo, 'materialType')
    },
    // 表单校验规则
    modelTreeFormRules() {
      return {
        directoryId: [
          {
            required: true,
            message: `请选择${this.pageTitle}分类/路径`,
            trigger: 'change',
          },
        ],
        modelFile: [
          {
            required: true,
            message: `请上传${this.pageTitle}文件`,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error(`请上传${this.pageTitle}文件`))
                return
              }
              callback()
            },
          },
        ],
      }
    },
    chartletSize() {
      return 30
    }, // 贴图size大小
  },
  methods: {
    /**
     * @description 删除上传文件
     */
    async handleRemove(file, fileList, name, isRemoveTopPic) {
      console.log(file, 'namenamenamename')
      if (this.modelProps.editType === 'create') {
        this[name] = fileList
        const fileIndex = this.modelContextForm.modelFile.findIndex((i) => {
          return i.uid === file.uid
        })
        this.modelContextForm.modelFile.splice(fileIndex)
        return
      }
      this.saveLoading = true
      const res = await ModelServer.deleteDocumentFiles({
        documentFileId: file.id,
      })
      this.saveLoading = false
      if (res?.code === 0) {
        let successStr = '删除模型成功'
        if (name === 'modelMapsFileList') {
          successStr = '删除贴图成功'
        }
        if (name === 'modelPicFileList' && !isRemoveTopPic) {
          successStr = '删除缩略图成功'
        }
        if (name === 'modelPicFileList' && isRemoveTopPic) {
          successStr = '删除旧缩略图成功'
        }
        this.$message.success(successStr)
        const index = this[name].findIndex((item) => {
          return item.id === file.id
        })
        if (index !== -1) {
          this[name].splice(index, 1)
          this.modelContextForm.modelFile.splice(index, 1)
        }
      }
    },

    /**
     * @description 上传文件修改
     */
    async handleChange(file, fileList, listName) {
      const name = file.name
      const fileSuffix = name.substring(name.lastIndexOf('.')).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix) &&
        listName === 'fileList'
      ) {
        this.$message.warning(`上传文件只能是${this.accept.join('、')}`)
        return false
      }
      if (this.modelProps.editType === 'create') {
        this[listName] = fileList
        console.log(this.modelContextForm.modelFile, 'hgfvsdgfvyd')
        this.modelContextForm.modelFile = this.modelContextForm.modelFile.concat(this[listName])
        console.log(this.modelContextForm.modelFile, 'hgfvsdgfvyd')

        return true
      }
      const formData = new FormData()
      formData.append('standardId', this.moduleConfig.VUE_APP_STANDARD_ID)
      formData.append('documentId', this.modelForm.id)
      formData.append('file', file.raw)
      this.saveLoading = true
      const res = await ModelServer.uploadReleFile(formData)
      this.saveLoading = false
      if (res?.code === 0) {
        if (listName === 'fileList' && this.config.isVulkan) {
          _.forEach(res.data, (item) => {
            if (item.fileIdOrigin) {
              this.parseQueue.push({
                fileId: item.fileIdOrigin,
                fileUid: file.uid,
              })
            }
          })
          if (!this.showModelView && this.parseQueue.length) {
            this.parseModelTag()
          }
        }
        if (listName === 'modelPicFileList' && this[listName].length === 1) {
          this.handleRemove(this[listName][0], this[listName], 'modelPicFileList', true)
        }
        let successStr = '添加模型成功'
        if (listName === 'modelMapsFileList') {
          successStr = '添加贴图成功'
        }
        if (listName === 'modelPicFileList') {
          successStr = '添加缩略图'
        }
        this.$message.success(successStr)
        this.modelContextForm.modelFile.push(file)
        this[listName].push(file)
        console.log(this[listName], 'this[listName]')
        this.$nextTick(() => {
          this.$refs.modelForm.clearValidate(['modelFile'])
        })
        return true
      }
      return false
    },

    /**
     * @description 目录树懒加载
     */
    async loadTreeData(node, resolve) {
      this.treeLoading = true
      const res = await ModelServer.getTreeNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: '', // 文档目录名称(模糊查询)
        isRoot: node.level === 0, // 是否是根节点
        nodeId: node?.data?.id, // 当前节点id
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        resolve(res.data)
        return
      }
      resolve([])
    },
    // 初始化表单数据
    async initFormData() {
      this.modelContextForm = { ...this.modelForm }
      if (this.modelProps.editType === 'edit') {
        const getFileInfo = ModelServer.getDocumentFiles({
          standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
          id: this.modelContextForm.id,
        })
        const getTreeNode = ModelServer.getTreeNodeById({
          id: this.modelForm.folder_id,
        })
        const [fileInfo, nodeInfo] = await Promise.all([getFileInfo, getTreeNode])
        if (fileInfo) {
          fileInfo.forEach((item) => {
            item.name = item.fileName
          })
          this.fileList = fileInfo.filter((i) => {
            const str = i.fileName.split('.')
            return str[str.length - 1] === 'pr'
          })
          this.modelMapsFileList = fileInfo.filter((i) => {
            const str = i.fileName.split('.')
            return str[str.length - 1] === 'zip'
          })
          this.modelPicFileList = fileInfo.filter((i) => {
            const str = i.fileName.split('.')
            return ['jpg', 'png', 'jpeg'].includes(str[str.length - 1])
          })
          this.$set(this.modelContextForm, 'modelFile', [...fileInfo])
        }
        if (nodeInfo?.code === 0 && nodeInfo.data) {
          this.$set(this.modelContextForm, 'directoryId', this.modelForm.folder_id)
          this.$set(this.modelContextForm, 'modelClassName', nodeInfo.data.name)
          this.pathId = this.modelForm.folder_id
          this.pathStr = nodeInfo.data.name
          this.$nextTick(() => {
            this.$refs.modelForm.clearValidate(['directoryId'])
          })
        }
      }
    },
    // 下拉数点击
    treeNodeClick(node) {
      this.modelContextForm.directoryId = node.id
      this.modelContextForm.modelClassName = node.path
      this.pathId = node.id
      this.pathStr = node.path
      this.$refs.modelTree.blur()
      this.$nextTick(() => {
        this.$refs.modelForm.clearValidate(['directoryId'])
      })
    },

    // 关闭弹框事件
    close(isUpdated) {
      this.$emit('closeModelDialog', isUpdated)
    },
    // 表单保存
    save() {
      this.$refs.modelForm.validate(async (valid) => {
        if (!valid) return
        if (this.modelProps.editType === 'create') {
          this.saveLoading = true
          const prIndex = this.modelContextForm.modelFile.findIndex((i) => {
            const str = i.name.split('.')
            return str[str.length - 1]
          })
          if (prIndex < 0) {
            return
          }
          const formData = new FormData()
          formData.append('folderId', this.modelContextForm.directoryId)
          formData.append('standardId', this.moduleConfig.VUE_APP_STANDARD_ID)
          formData.append('isAddDocument', true)
          formData.append('classId', this.moduleConfig.VUE_APP_CLASS_ID)
          const file = this.modelContextForm.modelFile[prIndex]
          formData.append('file', file.raw)
          const res = await ModelServer.createModelFileV2(formData)
          if (res?.code === 0) {
            const headers = [
              'DocumentId',
              'DocumentFileId',
              'FileId',
              '上传文件',
              '上传结果',
              '提示信息',
            ]
            const result = [headers]
            this.saveLoading = false
            this.parseQueue = []
            _.forEach(res.data, (item) => {
              if (item.fileId) {
                this.parseQueue.push({
                  fileId: item.fileId,
                  fileUid: file.uid,
                })
              }
              result.push([
                item.documentId,
                item.documentFileId,
                item.fileId,
                item.file,
                item.result,
                item.message,
              ])
            })
            const workbook = XLSX.utils.book_new()
            const worksheet = XLSX.utils.aoa_to_sheet(result)
            XLSX.utils.book_append_sheet(workbook, worksheet, '文档上传结果')
            XLSX.writeFile(workbook, '文件导入明细.xlsx')
            if (this.parseQueue.length && this.config.isVulkan) {
              this.isParseModel = true
              this.parseModelTag()
            } else {
              this.close(true)
            }
            this.$message.success('成功')
          }
        } else {
          this.saveLoading = true

          // 更新基本信息
          const currentStandardItemCode = this.currentStandardItemCode
          console.log(
            this.currentStandardItemCode,
            currentStandardItemCode,
            this.modelForm,
            'currentStandardItemCode-11'
          )
          const value = {}
          value[`${currentStandardItemCode}_Document.code`] = this.modelForm[
            `${currentStandardItemCode}_Document.code`
          ]
          value[`${currentStandardItemCode}_Document.name`] = this.modelForm[
            `${currentStandardItemCode}_Document.name`
          ]
          value[`${currentStandardItemCode}_Document.revision`] = this.modelForm[
            `${currentStandardItemCode}_Document.revision`
          ]
          const baseRes = await ModelServer.saveDynamicTableData({
            classId: this.moduleConfig.VUE_APP_CLASS_ID, // FL3DMS记录id
            standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
            folderId: this.modelContextForm.directoryId, // 目录树id
            dataId: this.modelForm.id, // 文档id
            value,
          })
          this.saveLoading = false
          if (baseRes?.code === 0) {
            this.$message.success('成功')
            this.close(true)
          }
        }
      })
    },
    async parseModelTag() {
      if (this.parseQueue.length === 0) {
        this.showModelView = false
        this.modelParams = []
        this.modelData = {}
        this.modelName = ''
        return
      }
      this.saveLoading = true
      const data = this.parseQueue.shift()
      const fileRes = await DocumentService.getDocumentFileType({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
        fileId: data.fileId,
      })
      const file = _.find(this.fileList, { uid: data.fileUid })
      this.currentParseFileUid = data.fileUid
      this.$set(file, 'msg', '模型对象获取中（请不要关闭）')
      this.$set(file, 'parse', true)
      this.$set(file, 'percent', 0)
      if (fileRes?.code === 0) {
        const name = fileRes.data.fileNameOrigin || fileRes.data.fileName
        const modelType = name
          .split('.')
          .at(-1)
          .toLowerCase()
        this.modelParams = [
          {
            ..._.pick(fileRes.data, ['fileId', 'documentId']),
            name,
            type: modelType,
            md5: fileRes.data.fileOriginMd5,
          },
        ]
        this.modelData = {
          defaultModelId: fileRes.data.documentId,
        }
        this.modelName = fileRes.data.documentId
        this.showModelView = true
      }
    },
    async loadedAllModel() {
      try {
        const tags = []
        const root = await this.mainPlayer.Native.Node.getRoot()
        const children = await this.mainPlayer.Native.Node.collectChildrenWithCode(root)
        const childrenInfo = await this.mainPlayer.Native.Node.getProperty(children, ['code'])
        _.forEach(childrenInfo, (item) => {
          if (item.code) {
            tags.push(item.code)
          }
        })
        const res = await ModelServer.analysisModelTag({
          standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
          documentId: this.modelName,
          tags,
        })
        this.saveLoading = false
        const file = _.find(this.fileList, { uid: this.currentParseFileUid })
        if (res && res.code === 0) {
          this.$set(file, 'msg', '解析中')
          this.getParseProgress({
            file,
            progressKey: res.details.progressKey,
          })
        } else {
          this.$set(file, 'msg', '解析失败')
        }
        this.parseModelTag()
      } catch (error) {
        const file = _.find(this.fileList, { uid: this.currentParseFileUid })
        this.$set(file, 'msg', error)
        this.loadError()
      }
    },
    async getParseProgress(data) {
      const res = await documentManagementService.getDocumentBatchRelationProgress(data.progressKey)
      if (res) {
        this.$set(data.file, 'percent', res.currentProgress)
        if (res.hasError) {
          this.$set(data.file, 'msg', res.status)
        } else if (res.isCompleted) {
          this.$set(data.file, 'msg', '解析完成')
        } else if (res.currentProgress !== 100) {
          setTimeout(() => {
            this.getParseProgress(data)
          }, 1500)
        }
      }
    },
    loadError() {
      this.parseQueue = []
      this.showModelView = false
      this.modelParams = []
      this.modelData = {}
      this.modelName = ''
      this.saveLoading = false
    },
  },
  created() {
    // 初始化表单数据
    this.initFormData()
  },
}
</script>

<style lang="scss">

.model-select-tree .el-select-dropdown__item {
  height: unset !important;
  line-height: unset !important;
  background: transparent !important;
}

.model-select-tree .el-tree-node__label {
  color: #000 !important;
}

</style>
<style scoped lang="scss">

</style>
